export const SESSION_EXPIRED_EVENT = 'session-expired' as const

/**
 * Route prefixes where an unauthenticated visitor is expected.
 * A 401 on these paths means "you never had a session", not "your session
 * expired", so the session-expired modal must not be shown there.
 */
export const UNAUTHENTICATED_ROUTE_PREFIXES = [
  '/login',
  '/signup',
  '/register',
  '/confirm-email',
  '/validate-email',
  '/validate-private-email',
  '/reset-password',
  '/recover-password',
] as const
